import type {Express} from 'express';
import {ALLOWED_FILE_EXTENSIONS} from '../constant';

export function isFilesContainNotAllowedExtentions(
  files: Express.Multer.File[] | File[]
) {
  return files.find(file => {
    const extension =
      ('originalname' in file ? file.originalname : file.name)
        .toLowerCase()
        .split('.')
        .pop() || '';

    return !ALLOWED_FILE_EXTENSIONS.includes(`.${extension}`);
  });
}
